// extracted by mini-css-extract-plugin
export default {"details":"details__ZmU4Y","facets":"facets__NjQ0Y","location":"location__ZWJlO","pricing":"pricing__M2U0N","dot":"dot__M2U2Z","detailsItem":"detailsItem__MDFkM"};